module.exports = require('./helpers/bundle-url').getBundleURL('2Xr4i') + "logo-dark.eefe0b7f.svg";